import { Component } from '@angular/core';

@Component({
  selector: 'app-page-404',
  templateUrl: './page-404.component.html',
  styleUrls: ['./page-404.component.css'],
  host: {
    class: 'app-page'
  }
})
export class Page404Component {

}
